import React, { useState } from "react";
import Button from '@material-ui/core/Button';
import {Container, Row } from 'react-bootstrap';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tappable from 'react-tappable';

import "../cart/css/cart.css";
export default function MostrarVideos(props) {
  const { link, left, top, width, height } = props;
  const [openVideo, setOpenVideo] = useState(false);

  const handleClickOpenVideo = () => {
    //console.log(idhola);
    setOpenVideo(true);
  };
  const handleCloseVideo = () => {
    setOpenVideo(false);
  };
         {/*} style={{left: left, top: top}} {*/}
  return (
    <>

 <button
    style={{ left: left, top: top, width: width, height: height }} 
   className="image_wrapper"
 
        onClick={()=>handleClickOpenVideo()}
        >
          
  </button>
 

<Container>
  <Row>
      <Dialog
        open={openVideo}
        onClose={handleCloseVideo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Container>
          {"Video: "}
          </Container>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <iframe width="400" height="306" src={link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseVideo} color="danger">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Row>
</Container>
    </>
  );
}
